import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import type { ResolvedReviewsContent } from "resolvers/data/reviewsContentResolver";

import styles from "./reviewsPageContent.module.scss";

const cx = classNames.bind(styles);

const ReviewsPageContent = ({ image, title, text }: ResolvedReviewsContent) => {
    return (
        <div className={cx("contentWrapper")}>
            <div className={cx("imageWrapper")}>
                <Image
                    src={image.src}
                    alt={image.alt}
                    layout="fill"
                    objectFit="cover"
                    className={cx("image")}
                    heroImage
                ></Image>
            </div>
            <h1 className={cx("title")}>{title}</h1>
            <p className={cx("text")}>{text}</p>
        </div>
    );
};

export default ReviewsPageContent;
